"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortMostRecent = exports.sortNameAsc = void 0;
const sortNameAsc = (data) => {
    return [...data].sort((current, next) => current.name.localeCompare(next.name));
};
exports.sortNameAsc = sortNameAsc;
const sortMostRecent = (data) => {
    return [...data].sort((current, next) => next.lastActivityTime - current.lastActivityTime);
};
exports.sortMostRecent = sortMostRecent;
